import { useEffect, useRef } from 'react';
import { usePrevious } from 'react-use';

interface UseScrollToLatestConversationThreadMessageArgs {
  messagesLength: number;
}

export function useScrollToLatestConversationThreadMessage({
  messagesLength,
}: UseScrollToLatestConversationThreadMessageArgs) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const prevMessagesLength = usePrevious(messagesLength);

  // Scroll to bottom when messagesLength changes
  useEffect(() => {
    if (prevMessagesLength !== messagesLength) {
      messagesEndRef.current?.scrollIntoView({
        inline: 'end',
        block: 'center',
        behavior: 'smooth',
      });
    }
  }, [messagesLength, prevMessagesLength]);

  return { messagesEndRef };
}
